/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 간소화된 태그 정보
 */
export type SimpleTripTagInfo = {
  /**
   * 태그 이름
   */
  tagName: string;
  /**
   * 태그 타입 (BUSINESS: 비즈니스 태그, CUSTOM: 커스텀 태그)
   */
  tagType: SimpleTripTagInfo.tagType;
};
export namespace SimpleTripTagInfo {
  /**
   * 태그 타입 (BUSINESS: 비즈니스 태그, CUSTOM: 커스텀 태그)
   */
  export enum tagType {
    BUSINESS = 'BUSINESS',
    CUSTOM = 'CUSTOM',
  }
}

